// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"6df9326e","204":"921cb45c","697":"327809c0"}[chunkId] + ".chunk.css";
};